import { Routes, RouterModule } from "@angular/router";
import { LoginGuard } from "./LoginGuard";
import { RestrictedUserGuard } from "./RestrictedUserGuard";
import { NonAdminUserGuard } from "./NonAdminUserGuard";

import { HomeComponent } from "./home/home.component";
import { SchoolProfileComponent } from "./school-profile";
import { StudentProfileComponent } from "./student-profile";
import { SchoolComparisonComponent } from "./school-comparison";
import { StudentComparisonComponent } from "./student-comparison";
import { UsageComponent } from "./usage";
import { MetricSettingsComponent } from "./metric-settings";
import { DashboardConfigSettingsComponent } from "./dashboard-config-settings";
import { DemographicBreakdownsComponent } from "./demographic-breakdowns";
import { SchoolConfigurationsComponent } from "./school-configurations";
import { MetricConfigurationsComponent } from "./metric-configurations";
import { VisibilitySettingsComponent } from "./dashboard-elements/visibility-settings/visibility-settings.component";
import { MetricSettingsEditorComponent } from "./dashboard-elements/metric-settings-editor";

const routes: Routes = [
  { path: "", component: HomeComponent, canActivate: [LoginGuard] },
  {
    path: "profile/school",
    component: SchoolProfileComponent,
    canActivate: [LoginGuard, RestrictedUserGuard],
  },
  {
    path: "profile/student",
    component: StudentProfileComponent,
    canActivate: [LoginGuard, RestrictedUserGuard],
  },
  {
    path: "profile/student/:studentId",
    component: StudentProfileComponent,
    canActivate: [LoginGuard, RestrictedUserGuard],
  },
  {
    path: "profile/school/:id",
    component: SchoolProfileComponent,
    canActivate: [LoginGuard, RestrictedUserGuard],
  },
  {
    path: "comparison/school",
    component: SchoolComparisonComponent,
    canActivate: [LoginGuard],
  },
  {
    path: "comparison/student",
    component: StudentComparisonComponent,
    canActivate: [LoginGuard, RestrictedUserGuard],
  },
  {
    path: "usage",
    component: UsageComponent,
    canActivate: [LoginGuard, RestrictedUserGuard],
  },
  {
    path: "metric/settings",
    component: MetricSettingsComponent,
    canActivate: [LoginGuard, NonAdminUserGuard],
    children: [
      { path: "", redirectTo: "visibility", pathMatch: "full" },
      { path: "visibility", component: VisibilitySettingsComponent },
      { path: "editor", component: MetricSettingsEditorComponent },
      { path: "visibility/:metricId", component: VisibilitySettingsComponent },
      { path: "editor/:metricId", component: MetricSettingsEditorComponent },
    ],
  },
  {
    path: "data-configuration/settings",
    component: DashboardConfigSettingsComponent,
    canActivate: [LoginGuard, NonAdminUserGuard],
    children: [
      { path: "", redirectTo: "demographic", pathMatch: "full" },
      { path: "demographic", component: DemographicBreakdownsComponent },
      { path: "configuration", component: MetricConfigurationsComponent },
      { path: "schools", component: SchoolConfigurationsComponent },
      { path: "configuration/:id", component: MetricConfigurationsComponent },
      { path: "demographic/:id", component: DemographicBreakdownsComponent },
      { path: "schools/:id", component: SchoolConfigurationsComponent },
    ],
  },
  { path: "**", redirectTo: "" },
];

// - Updated Export
export const routing = RouterModule.forRoot(routes);
